// PartA6.js - Part A6 Online Courses & Skills for Life component (2 Pages)
import React, { useState, useEffect } from 'react';
import { Button, message, Pagination } from 'antd';
import { SaveOutlined, ReloadOutlined } from '@ant-design/icons';
import { getAccessToken } from '../../authClient';
import PartA6OnlineCourses from './components/PartA6OnlineCourses';
import PartA6SkillsForLife from './components/PartA6SkillsForLife';
import { API_CONFIG } from '../../config/api';

const API_BASE_URL = API_CONFIG.BASE_URL;

const PartA6 = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    // Form data state for Part A6
    const [formData, setFormData] = useState({
        // Page 1: Online Courses - Course selections
        course_public_speaking: false,
        course_formal_creative_writing: false,
        course_health_nutrition_literacy: false,
        course_environmental_sustainability: false,
        course_citizen_politics_democracy: false,
        course_mental_wellness: false,
        course_gender_sensitivity: false,
        course_citizenship_values: false,
        course_ethics_reasoning: false,
        course_values_ethics_duties: false,
        course_fundamentals_neuroscience: false,
        course_artistic_literacy: false,
        course_coding: false,
        course_digital_marketing: false,
        course_computational_thinking: false,
        course_entrepreneurship: false,

        // Page 1: Additional planning fields
        course_planning_notes: '',
        teacher_consultation_notes: '',

        // Page 2: Skills for Life - Text areas
        important_life_skill: '',
        skill_development_experiences: '',
        why_skill_important: '',
        future_skill_to_develop: ''
    });

    useEffect(() => {
        loadExistingData();
    }, []);

    const loadExistingData = async () => {
        try {
            const token = getAccessToken();
            const response = await fetch(`${API_BASE_URL}/secondary/user/hpc-profile/part-a6`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                if (data.exists && data.part_a_6) {
                    setFormData(prevData => ({
                        ...prevData,
                        ...data.part_a_6
                    }));
                }
            }
        } catch (error) {
            console.error('Error loading existing data:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            const token = getAccessToken();
            const response = await fetch(`${API_BASE_URL}/secondary/user/hpc-profile/part-a6`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                message.success('Part A6 saved successfully!');
            } else {
                throw new Error('Failed to save Part A6');
            }
        } catch (error) {
            console.error('Error saving Part A6:', error);
            message.error('Failed to save Part A6');
        } finally {
            setSaving(false);
        }
    };

    const renderCurrentPage = () => {
        switch (currentPage) {
            case 2:
                return (
                    <PartA6OnlineCourses
                        formData={formData}
                        handleInputChange={handleInputChange}
                    />
                );
            case 1:
                return (
                    <PartA6SkillsForLife
                        formData={formData}
                        handleInputChange={handleInputChange}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <div className="part-a6-container">
            {/* Page Content */}
            {renderCurrentPage()}

            {/* Navigation and Save Controls */}
            <div className="page-controls">
                <div className="pagination-section">
                    <Pagination
                        current={currentPage}
                        total={2}
                        pageSize={1}
                        onChange={setCurrentPage}
                        showSizeChanger={false}
                        showQuickJumper={false}
                        showTotal={(total, range) => `Page ${range[0]} of ${total}`}
                    />
                </div>

                <div className="save-section">
                    <Button
                        type="primary"
                        size="large"
                        icon={<SaveOutlined />}
                        onClick={handleSave}
                        loading={saving}
                        className="save-button"
                    >
                        {saving ? 'Saving...' : 'Save Part A6'}
                    </Button>

                    <Button
                        size="large"
                        icon={<ReloadOutlined />}
                        onClick={loadExistingData}
                        className="reload-button"
                        style={{ marginLeft: '10px' }}
                    >
                        Reload Data
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default PartA6;